import { Components } from "appworks/components/components";
import { FadeIn, FadeOut } from "appworks/graphics/animation/base-animations";
import { gameState } from "appworks/model/game-state";
import { Gameplay } from "appworks/model/gameplay/gameplay";
import { Services } from "appworks/services/services";
import { State } from "appworks/state-machine/states/state";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { Sequence } from "appworks/utils/contracts/sequence";
import { tgrInstantWinsComponent } from "components/tgr-instant-wins";
import { TGRSymbolComponent } from "components/tgr-symbol";
import { gameLayers } from "game-layers";
import { TGRInstantWin, TGRInstantWinResult } from "integration/builders/results/tgr-instant-win-result";
import { MatrixComponent } from "slotworks/components/matrix/matrix-component";
import { TGRSoundEvent } from "tgr-sound-event-enum";

const COLLECT_DURATION: number = 800;
const WIN_DURATION: number = 1000;
const STAGGER: number = 300;
const TOTAL_WIN_SHOW_TIME: number = 1000;

export class TGRShowInstantWins extends State {

    public onEnter(): void {
        super.onEnter();

        const gameplay: Gameplay = gameState.getCurrentGame();
        const instantWinResult: TGRInstantWinResult = gameplay.getCurrentRecord().getResultsOfType(TGRInstantWinResult)[0];
        const collectSymbol: TGRSymbolComponent = Components.get(MatrixComponent).getSymbol(
            instantWinResult.collectSymbolPosition.x,
            instantWinResult.collectSymbolPosition.y
        ) as TGRSymbolComponent;

        const collectContracts: Array<() => Contract<void>> = [];
        instantWinResult.instantWins.forEach((instantWin: TGRInstantWin, i: number) => {
            const delay: number = STAGGER * i;
            collectContracts.push(
                () => Contract.getDelayedContract(delay, () =>  tgrInstantWinsComponent.animateCollect(instantWinResult, instantWin, COLLECT_DURATION))
            );
        });

        const winContracts: Array<() => Contract<void>> = [];
        let totalWin: number = 0;
        instantWinResult.instantWins.forEach((instantWin: TGRInstantWin, i: number) => {
            const delay: number = COLLECT_DURATION + (STAGGER * i);
            totalWin += instantWin.cashWon;
            winContracts.push(
                () => Contract.getDelayedContract(delay, () =>  tgrInstantWinsComponent.animateWin(instantWin, WIN_DURATION))
            );
        });

        new Sequence([
            () => new Parallel([
                () => Contract.wrap(() => Services.sound.customEvent(TGRSoundEvent.monkeysymbol_animate)),
                () => collectSymbol.win()
            ]),
            () => new Parallel([
                () => gameLayers.InstantWins.setScene("instant_win"),
                () => FadeOut(gameLayers.TigerHeader.getSprite("logo"), 350)
            ]),
            () => new Parallel([
                ...collectContracts,
                ...winContracts,
                () => tgrInstantWinsComponent.incrementWinTo(totalWin, COLLECT_DURATION + WIN_DURATION)
            ]),
            () => Contract.getDelayedContract(TOTAL_WIN_SHOW_TIME, () => new Parallel([
                () => gameLayers.InstantWins.defaultScene(),
                () => FadeIn(gameLayers.TigerHeader.getSprite("logo"), 350)
            ]))
        ]).then(() => this.complete());
    }
}
